/* Fransk katalog for locale-purchases-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'buy.remove': 'Retirer',
  'buy.openPreview': 'Ouvrir l\'aperçu',
  'buy.noPreview': 'Aucun aperçu',
  'buy.savedInBackend': 'Le justificatif est enregistré.',
  'buy.open': 'Ouvrir',
  'buy.addMoreDocs': 'Ajouter d\'autres justificatifs',
  'buy.addMoreDocsHelp': 'Joignez d\'autres reçus ou pages au même achat. Tous les justificatifs joints sont listés ici.',
  'buy.uploadDoc': 'Importer un justificatif',
  'buy.uploadDocHelp': 'Joignez le reçu ou la facture de l\'achat. Vous pouvez faire glisser un fichier, en choisir un sur votre ordinateur ou récupérer un justificatif dans la boîte de réception.',
  'buy.dropOrPick': 'Déposez ou choisissez un justificatif',
  'buy.storedIn': 'Le PDF ou l\'image est stocké dans Firebase/la boîte de réception.',
  'buy.fromInbox': 'Récupérer de la boîte de réception',
  'buy.attachments': 'Pièces jointes',
  'buy.pickFiles': 'Choisir des fichiers',
  'buy.dropAttachments': 'Déposez les pièces jointes ici',
  'buy.attachmentsNote': 'Les pièces jointes sont envoyées au serveur lors de l\'enregistrement de l\'écriture.',
  'buy.supplierSearch': 'Rechercher ou ajouter un fournisseur...',
  'buy.supplierSearchShort': 'Rechercher ou ajouter un fournisseur',
  'buy.supplierClose': 'Fermer la sélection du fournisseur',
  'buy.supplierNone': 'Aucun fournisseur trouvé.',
  'buy.supplierNew': 'Nouveau fournisseur',
  'buy.name': 'Nom',
  'buy.org': 'N° d\'org.',
  'buy.email': 'E-mail',
  'buy.phone': 'Téléphone',
  'buy.accountClose': 'Fermer la sélection du compte',
  'buy.searchShort': 'Rechercher ...',
  'buy.noAccountMatch': 'Aucun compte ne correspond à la recherche.',
  'buy.fromInboxRead': 'Récupéré de la boîte de réception - SuperPlumma a lu ce qu\'elle pouvait.',
  'buy.docHelp': 'Le justificatif est le reçu ou la facture qui documente l\'achat. Faites glisser une image ou un PDF - ou touchez pour choisir un fichier. SuperPlumma lit la date, le montant, le fournisseur et la TVA, et propose comment comptabiliser l\'achat.',
  'buy.dropReceipt': 'Déposez le reçu ici',
  'buy.dropReceiptHelp': 'Récupérez le justificatif dans vos fichiers, ou choisissez « Récupérer de la boîte de réception » pour utiliser un justificatif déjà reçu par e-mail. SuperPlumma lit le contenu automatiquement.',
  'buy.upload': 'Importer',
  'buy.type': 'Type d\'achat',
  'buy.typeHelp': 'Choisissez comment enregistrer l\'achat. « Achat payé » est un achat déjà réglé. « Facture fournisseur » s\'utilise lorsque la facture sera payée plus tard ou est partiellement payée (elle devient une dette fournisseur). « Brouillons » affiche les achats commencés que vous n\'avez pas encore comptabilisés.',
  'buy.description': 'Description',
  'buy.descriptionPh': 'Ex. abonnement ou déplacement',
  'buy.toggleVat': 'Basculer entre HT et TTC',
  'buy.amountExInc': 'Montant HT/TTC',
  'buy.amountExIncHelp': 'Touchez pour choisir de saisir le montant hors TVA (net) ou TVA comprise (brut). Plumme convertit automatiquement entre les deux. « HT » est le coût lui-même, « TTC » est le montant total que vous avez payé.',
  'buy.vatRate': 'Taux de TVA',
  'buy.vatRateHelp': 'Le taux de TVA de l\'achat. 25 % est le taux normal, 15 % s\'applique aux denrées alimentaires, 12 % notamment au transport de personnes et à l\'hébergement, et 0 % est utilisé pour les achats exonérés. La TVA sur un achat est de la TVA déductible.',
  'buy.pickCategory': 'Compte/catégorie',
  'buy.category': 'Catégorie',
  'buy.categoryHelp': 'Le type de charge. La catégorie détermine le compte sur lequel l\'achat est comptabilisé, afin qu\'il figure correctement dans le compte de résultat et la skattemelding.',
  'buy.supplier': 'Fournisseur',
  'buy.accountFromHistory': 'Compte de charge proposé d\'après les achats précédents auprès de ce fournisseur. Vous pouvez le modifier sur la ligne d\'achat.',
  'buy.date': 'Date d\'achat',
  'buy.invoiceNumber': 'Numéro de facture',
  'buy.invoiceNumberPh': 'Ex. 100245',
  'buy.dueDate': 'Date d\'échéance',
  'buy.lines': 'Lignes',
  'buy.linesHelp': 'Chaque ligne est une charge du justificatif, avec son propre montant, taux de TVA et catégorie. Si le reçu comporte plusieurs articles ou taux de TVA différents, créez une ligne par type. Vous pouvez faire glisser les lignes pour changer l\'ordre.',
  'buy.addLine': 'Ajouter une ligne',
  'buy.payment': 'Paiement',
  'buy.paymentHelp': 'Pour une facture fournisseur, indiquez si elle est payée. Les factures impayées sont enregistrées comme dettes fournisseurs ouvertes, afin que le paiement puisse être saisi plus tard.',
  'buy.immediatePaymentHelp': 'Un achat ordinaire est déjà payé. Choisissez le compte de paiement et la date du paiement.',
  'buy.paid': 'Payé',
  'buy.unpaid': 'Non payé',
  'buy.paidFrom': 'Payé depuis',
  'buy.choosePaymentSource': 'Choisir la source de paiement',
  'buy.paidDate': 'Date de paiement',
  'buy.paidDateHelp': 'La date à laquelle l\'achat a été payé. La date d\'achat détermine la période comptable et de TVA de l\'achat lui-même.',
  'buy.dateLabel': 'Date',
  'buy.addPartPayment': 'Ajouter un paiement partiel',
  'buy.addPartPaymentHelp': 'Enregistrez un paiement supplémentaire. La somme des paiements partiels est déduite du total - le reste s\'affiche comme « restant ».',
  'buy.remaining': 'Restant',
  'buy.remainingHelp': 'La différence entre le montant total et les paiements partiels enregistrés. Si elle est de 0, l\'achat est entièrement réglé.',
  'buy.preview': 'Aperçu',
  'buy.previewHelp': 'Aperçu du justificatif importé. Si vous n\'en avez pas encore importé, vous pouvez le faire ici.',
  'buy.dropReceiptLong': 'Déposez le reçu ici - faites glisser une image ou un PDF, ou touchez pour choisir un fichier.',
  'buy.summaryHelp': 'Le récapitulatif affiche le net, la TVA et le total que vous payez.',
  'buy.saveDraft': 'Enregistrer le brouillon',
  'buy.saveDraftHelp': 'Enregistre l\'achat comme brouillon sans le comptabiliser. Les justificatifs et paiements ne sont marqués comme comptabilisés qu\'une fois l\'achat finalisé.',
  'buy.title': 'Achat payé',
  'buy.subtitle': 'Enregistrez un achat - importez le justificatif et nous proposons le reste.',
  'buy.drafts': 'Brouillons',
  'buy.draftsSub': 'Achats et immobilisations commencés mais pas encore comptabilisés',
  'buy.draftsSearchPh': 'Fournisseur, description, n° de facture ou montant',
  'buy.showMore': 'Afficher plus',
  'buy.noDrafts': 'Aucun brouillon',
  'buy.invoiceNoShort': 'N° de facture',
  'buy.delete': 'Supprimer',
  'buy.deleteDraftTitle': 'Supprimer le brouillon ?',
  'buy.deleteDraftConfirm': 'Oui, supprimer le brouillon',
  'buy.deleteDraftBody': 'Voulez-vous vraiment supprimer le brouillon de',
  'buy.resetTitle': 'Réinitialiser le formulaire et recommencer',
  'buy.reset': 'Réinitialiser',
  'buy.howRegister': 'Comment souhaitez-vous enregistrer l\'achat ?',
  'buy.howRegisterSub': 'Importez de préférence d\'abord le justificatif - nous vous proposerons ensuite le reste.',
  'buy.stepByStep': 'Pas à pas',
  'buy.stepByStepHelp': 'Vous guide dans l\'achat une partie à la fois - d\'abord le justificatif, puis la date, les lignes et le paiement. Idéal pour prendre votre temps.',
  'buy.stepByStepShort': 'D\'abord le justificatif, puis la date, les lignes et le paiement.',
  'buy.onePage': 'Tout sur une page',
  'buy.onePageHelp': 'Affiche l\'ensemble du formulaire d\'achat sur une seule page. Idéal si vous avez l\'habitude d\'enregistrer des achats et voulez tout avoir sous les yeux.',
  'buy.onePageShort': 'Tout le formulaire d\'achat réuni.',
  'buy.toSteps': 'Passer au mode pas à pas',
  'buy.toOnePage': 'Passer au mode tout sur une page',
  'buy.back': 'Retour',
  'buy.next': 'Suivant',
  'buy.backToVouchers': 'Retour aux transactions',
  'buy.salesType': 'Type de vente',
  'buy.paidTo': 'Payé sur',
  'buy.payOperating': 'Compte d\'exploitation',
  'buy.payCash': 'Espèces',
  'buy.payPrivate': 'Privé',
  'buy.whatSold': 'Qu\'avez-vous vendu ?',
  'buy.amountExVat': 'Montant HT',
  'buy.amountIncVat': 'Montant TTC',
  'buy.vatLabel': 'TVA',
  'buy.otherSale': 'Autre vente',
  'buy.invoiceOrQuote': 'Facture / devis',
  'buy.switchMode': 'Changer de mode',
  'buy.moreOptions': 'Plus d\'options',
  'buy.postAs': 'Comptabiliser comme',
  'buy.backendUploadNotReady': 'L\'import côté serveur n\'est pas prêt.',
  'buy.multipleUploadedShowFirst': 'Plusieurs justificatifs ont été importés. Le premier est affiché ici.',
  'buy.uploadFailed': 'Impossible d\'importer le justificatif.',
  'buy.dropReceiptTitle': 'Déposez le reçu ici',
  'buy.dropReceiptSubtitle': '...et nous vous aiderons à le classer correctement. Faites glisser une image ou un PDF, ou appuyez pour choisir un fichier.',
  'buy.attachedCount': 'Justificatifs liés : {count}',
  'buy.uploading': 'Importation...',
  'buy.chooseFile': 'Choisir un fichier',
  'buy.dropToUpload': 'Déposez le justificatif pour l\'importer',
  'buy.accountFallbackOperating': 'Compte courant · 1920',
  'buy.accountFallbackCash': 'Espèces',
  'buy.accountFallbackPrivate': 'Avance personnelle',
  'buy.accountFallbackCash1900': 'Espèces - 1900',
  'buy.accountFallbackPrivate2060': 'Personnel - 2060',
  'buy.addSupplierQuery': 'Ajouter « {query} »',
  'buy.chartNotConnected': 'Le plan comptable n\'est pas connecté au stockage.',
  'buy.accountAdded': 'Le compte a été ajouté.',
  'buy.accountSaveFailed': 'Impossible d\'enregistrer le compte.',
  'buy.chooseAccount': 'Choisir un compte',
  'buy.forQuery': 'pour « {query} »',
  'buy.newCustomAccountTitle': 'Nouveau compte personnalisé',
  'buy.saving': 'Enregistrement...',
  'buy.saveAccount': 'Enregistrer le compte',
  'buy.accountNamePlaceholder': 'Ex. Développement logiciel',
  'buy.accountHelperText': 'Le compte devient disponible dans la recherche de comptes et est associé au compte standard pour les rapports et la clôture annuelle.',
  'buy.inventoryProduct': 'Article en stock',
  'buy.notTracked': 'Non suivi en stock',
  'buy.quantityInStock': 'Quantité entrée en stock',
  'buy.inStockCount': '{n} en stock',
  'buy.inventoryLineToggle': 'Suivre en stock',
  'buy.inventoryLineToggleHelp': 'Activez cette option lorsque l\'achat doit augmenter la quantité d\'un article en stock enregistré.',
  'buy.inventorySearchPlaceholder': 'Choisir un article en stock',
  'buy.inventorySearch': 'Rechercher par nom, numéro d\'article, SKU ou EAN',
  'buy.inventorySearchEmpty': 'Aucun article suivi en stock ne correspond à la recherche.',
  'buy.inventoryOpenProducts': 'Ouvrir les produits',
  'buy.inventoryUnitsInStock': 'en stock',
  'inventoryPurchase.settingsTitle': 'Suivi du stock sur les achats',
  'inventoryPurchase.settingsHelp': 'Affichez un champ de stock facultatif sur les lignes d\'achat, afin qu\'un achat puisse augmenter la quantité d\'un article en stock enregistré.',
  'inventoryPurchase.offHelp': 'Le champ de stock est masqué sur les nouveaux achats. Les produits et les mouvements de stock antérieurs sont conservés.',
  'inventoryPurchase.migratedTitle': 'Le suivi du stock sur les achats est activé',
  'inventoryPurchase.migratedText': 'L\'entreprise possède déjà des produits avec suivi automatique du stock. Le lien de stock sur les lignes d\'achat a donc été activé, afin que le flux de travail existant continue.',
  'inventoryPurchase.acknowledge': 'J\'ai compris',
  'inventoryPurchase.acknowledgeError': 'Impossible d\'enregistrer la confirmation.',
  'inventoryPurchase.openSettings': 'Ouvrir les paramètres',
  'inventoryPurchase.disableTitle': 'Désactiver le suivi du stock sur les achats ?',
  'inventoryPurchase.disableConfirm': 'Désactiver',
  'inventoryPurchase.disableWarning': 'Le champ de stock sera masqué sur les nouveaux achats. Les achats ne pourront plus être liés aux produits suivis en stock, et les quantités risquent d\'être erronées si elles ne sont pas vérifiées et ajustées manuellement.',
  'inventoryPurchase.disableHistory': 'Les produits existants et les mouvements de stock historiques ne sont pas supprimés. Comptez le stock et enregistrez manuellement les ajustements nécessaires.',
  'inventoryPurchase.enabledLabel': 'Suivi du stock sur les achats',
  'inventoryPurchase.disabledLabel': 'Suivi du stock sur les achats',
  'buy.noDescription': 'Sans description',
  'buy.attachmentFallback': 'Justificatif',
  'buy.lockVatTitle': 'La période de TVA a été déclarée',
  'buy.lockYearTitle': 'L\'exercice comptable est clôturé',
  'buy.lockBankTitle': 'La période bancaire est rapprochée',
  'buy.lockVatTarget': 'la période de TVA',
  'buy.lockYearTarget': 'la clôture annuelle',
  'buy.lockBankTarget': 'le rapprochement bancaire',
  'buy.lockWarningText': '{title}. Vous pouvez encore modifier la description et le compte de charges/la catégorie de l\'achat, mais la date d\'achat, le montant, le code TVA et les champs de paiement sont verrouillés. Ouvrez ou corrigez {target} si vous devez modifier ces champs.',
  'buy.lockVatWarningText': '{title}. La date d\'achat, le montant et le code TVA sont verrouillés, mais la description, le compte de charges/la catégorie et le compte de paiement peuvent encore être corrigés. Ouvrez ou corrigez {target} si la base de TVA doit changer.',
  'buy.backendSaveNotReady': 'L\'enregistrement côté serveur n\'est pas prêt.',
  'buy.needAtLeastOneLine': 'Ajoutez au moins une ligne d\'achat.',
  'buy.needDescriptionAllLines': 'Saisissez une description sur toutes les lignes avant de comptabiliser.',
  'buy.needContentForDraft': 'Ajoutez une ligne, un fournisseur ou un justificatif avant d\'enregistrer le brouillon.',
  'buy.needSupplierForInvoice': 'Choisissez un fournisseur ou saisissez un nom de fournisseur avant d\'enregistrer le paiement partiel/la facture fournisseur.',
  'buy.draftSaved': 'Brouillon enregistré.',
  'buy.attachmentUpdated': 'Le justificatif a été mis à jour.',
  'buy.invoiceRegisteredOpen': 'Facture enregistrée comme facture fournisseur ouverte.',
  'buy.purchaseBooked': 'Achat comptabilisé ! Le justificatif se trouve maintenant dans Transactions.',
  'buy.purchaseSaveFailed': 'Impossible d\'enregistrer l\'achat.',
  'buy.docsFetchedFromInbox': 'Justificatifs récupérés depuis la boîte de réception : {count}',
  'buy.fullPayment': 'Paiement intégral',
  'buy.partPayment': 'Paiement partiel',
  'buy.partPaymentWarning': 'Un paiement partiel est enregistré comme facture fournisseur. Le reste est comptabilisé en dette fournisseur sur le compte 2400 jusqu\'à son paiement.',
  'buy.partPaymentLabel': 'Paiement partiel {n}',
  'buy.remainingSuffix': '· restant',
  'buy.unpaidWillBeInvoice': 'Sans paiement enregistré, ceci est enregistré comme facture fournisseur ouverte. Vous pourrez enregistrer le paiement plus tard.',
  'buy.forgotReceiptTitle': 'Vous avez oublié le justificatif ?',
  'buy.registerInvoice': 'Enregistrer la facture',
  'buy.bookPurchase': 'Comptabiliser l\'achat',
  'buy.registerInvoiceHelp': 'Enregistre la facture comme dette fournisseur ouverte. Elle apparaît sous le fournisseur, et vous enregistrez le paiement une fois réglée.',
  'buy.bookPurchaseHelp': 'Enregistre l\'achat dans la comptabilité. Le justificatif est classé sous « Transactions », et les montants sont comptabilisés sur les bons comptes.',
  'buy.typeBadgeInvoice': 'Facture',
  'buy.typeBadgeAsset': 'Immobilisation',
  'buy.draftDeleteNotConnected': 'La suppression des brouillons n\'est pas connectée au serveur.',
  'buy.draftDeleted': 'Brouillon supprimé.',
  'buy.draftDeleteFailed': 'Impossible de supprimer le brouillon.',
  'buy.pageHelpDrafts': 'C\'est ici que vous enregistrez tous les achats de l\'entreprise. Choisissez « Brouillons » dans le menu déroulant pour voir les achats commencés que vous n\'avez pas encore comptabilisés.',
  'buy.draftsPageHelp': 'Les achats commencés mais non terminés sont enregistrés ici. Ouvrez un brouillon pour continuer, ou supprimez ceux dont vous n\'avez pas besoin.',
  'buy.viewOptionsLabel': 'Options d\'affichage',
  'buy.assetsLabel': 'Immobilisations',
  'buy.noDraftsMatchSearch': 'Aucun brouillon ne correspond à la recherche.',
  'buy.draftsEmptyHint': 'Les achats commencés que vous enregistrez comme brouillons apparaissent ici.',
  'buy.colSupplier': 'Fournisseur',
  'buy.noSupplier': 'Sans fournisseur',
  'buy.colType': 'Type',
  'buy.colInvoiceNo': 'N° de facture',
  'buy.colDate': 'Date',
  'buy.colAmount': 'Montant',
  'buy.thisPurchaseFallback': 'cet achat',
  'buy.cannotBeUndone': '? Cette action est irréversible.',
  'buy.formReset': 'Le formulaire a été réinitialisé',
  'buy.editPurchaseSubtitle': 'Mettez à jour le justificatif et enregistrez les modifications sur le serveur.',
  'buy.newPurchasePageHelp': 'C\'est ici que vous enregistrez tous les achats de l\'entreprise - marchandises, équipements, abonnements, déplacements. Importez le justificatif : SuperPlumma lit les détails et comptabilise la charge sur le bon compte avec la bonne TVA.',
  'buy.defaultLineDescription': 'Achat',
  'buy.customerFallback': 'Client',
  'buy.supplierAndDateTitle': 'Fournisseur et date',
  'buy.supplierAndDateInvoiceHelp': 'Auprès de qui vous avez acheté et quand. La date de facture est celle indiquée sur la facture, et la date d\'échéance est celle à laquelle elle doit être payée. Le numéro de facture est le numéro propre au fournisseur.',
  'buy.supplierAndDatePurchaseHelp': 'La date d\'achat détermine la période comptable et de TVA à laquelle l\'achat est rattaché. Utilisez la date figurant sur le reçu.',
  'buy.katFixedAssets': 'Immobilisations / équipement',
  'buy.katRent': 'Loyer',
  'buy.katPhoneInternet': 'Téléphone et internet',
  'buy.katSoftware': 'Logiciel / abonnement',
  'buy.katTravel': 'Déplacements et indemnités',
  'buy.katRepresentation': 'Frais de réception',
  'buy.acct4000': 'Matières premières et produits semi-finis',
  'buy.acct4300': 'Achats de marchandises destinées à la revente',
  'buy.acct4500': 'Prestations externes et sous-traitants',
  'buy.acct5000': 'Salaires des employés',
  'buy.acct5400': 'Cotisations patronales',
  'buy.acct5900': 'Cadeaux aux employés',
  'buy.acct6000': 'Amortissements',
  'buy.acct6100': 'Frais de fret et de transport',
  'buy.acct6200': 'Énergie, électricité et chauffage',
  'buy.acct6300': 'Loyer des locaux',
  'buy.acct6320': 'Collecte des déchets, eau, assainissement, etc.',
  'buy.acct6340': 'Éclairage, chauffage',
  'buy.acct6360': 'Nettoyage',
  'buy.acct6400': 'Location de machines',
  'buy.acct6500': 'Outillage et mobilier',
  'buy.acct6540': 'Mobilier et équipement',
  'buy.acct6550': 'Fournitures d\'exploitation',
  'buy.acct6560': 'Petites fournitures',
  'buy.acct6600': 'Réparation et entretien des bâtiments',
  'buy.acct6690': 'Réparation et entretien, autres',
  'buy.acct6700': 'Audit et comptabilité',
  'buy.acct6720': 'Assistance juridique',
  'buy.acct6790': 'Autres prestations externes',
  'buy.acct6800': 'Fournitures de bureau',
  'buy.acct6810': 'Frais informatiques',
  'buy.acct6820': 'Imprimés',
  'buy.acct6900': 'Téléphone',
  'buy.acct6940': 'Affranchissement',
  'buy.acct7000': 'Carburant des véhicules',
  'buy.acct7020': 'Entretien du véhicule',
  'buy.acct7040': 'Assurance et taxes des véhicules',
  'buy.acct7100': 'Indemnités kilométriques',
  'buy.acct7140': 'Frais de déplacement non déclarables',
  'buy.acct7150': 'Frais de repas et indemnités journalières',
  'buy.acct7160': 'Frais de déplacement déclarables',
  'buy.acct7300': 'Frais commerciaux',
  'buy.acct7320': 'Publicité et annonces',
  'buy.acct7350': 'Frais de réception déductibles',
  'buy.acct7360': 'Frais de réception non déductibles',
  'buy.acct7400': 'Cotisations',
  'buy.acct7500': 'Prime d\'assurance',
  'buy.acct7600': 'Licences, brevets et redevances',
  'buy.acct7700': 'Autres charges d\'exploitation',
  'buy.acct7770': 'Frais bancaires et de carte',
  'buy.acct7790': 'Autres charges',
  'buy.acct8050': 'Produits d\'intérêts',
  'buy.acct8150': 'Charges d\'intérêts',
  'buy.acct8300': 'Impôt exigible',
  'buy.fallbackCostName': 'Charge',
  'buy.fallbackAccountName': 'Compte',
  'buy.grp40': 'Coût des marchandises',
  'buy.grp43': 'Marchandises destinées à la revente',
  'buy.grp45': 'Achats de services',
  'buy.grp50': 'Salaires',
  'buy.grp54': 'Cotisations patronales',
  'buy.grp59': 'Charges de personnel',
  'buy.grp60': 'Amortissements',
  'buy.grp61': 'Fret et transport',
  'buy.grp62': 'Énergie et chauffage',
  'buy.grp63': 'Locaux',
  'buy.grp64': 'Location de machines et d\'équipement',
  'buy.grp65': 'Outillage et mobilier',
  'buy.grp66': 'Réparation et entretien',
  'buy.grp67': 'Prestations externes',
  'buy.grp68': 'Frais de bureau',
  'buy.grp69': 'Téléphone, affranchissement, etc.',
  'buy.grp70': 'Véhicules',
  'buy.grp71': 'Déplacements et indemnités',
  'buy.grp73': 'Ventes et réception',
  'buy.grp74': 'Cotisations',
  'buy.grp75': 'Assurance',
  'buy.grp76': 'Licences et redevances',
  'buy.grp77': 'Autres charges d\'exploitation',
  'buy.grp15': 'Créances à court terme',
  'buy.grp24': 'Dettes fournisseurs',
  'buy.groupAssets': 'Actifs',
  'buy.groupEquityAndLiabilities': 'Capitaux propres et dettes',
  'buy.groupIncome': 'Produits',
  'buy.groupCostOfGoods': 'Coût des marchandises',
  'buy.groupPayrollAndPersonnel': 'Salaires et charges de personnel',
  'buy.groupOtherOperating': 'Autres charges d\'exploitation',
  'buy.groupFinanceAndTax': 'Finances et impôts',
  'buy.groupAccountsFallback': 'Comptes',
  'rep.trial.onlyMovement': 'Afficher uniquement les comptes avec mouvements',
  'rep.trial.showInactive': 'Afficher aussi les comptes inactifs',
  'rep.trial.payrollLiability': 'Salaires dus',
  'rep.trial.holidayPayLiability': 'Indemnités de congés payés dues',
  'rep.trial.oneEmployee': '{n} employé',
  'rep.trial.employeeCount': '{n} employés',
  'rep.trial.otherPayrollLiability': 'Toutes les écritures sur 2930',
  'rep.trial.allAccountEntries': 'Toutes les écritures sur {account}',
  'rep.trial.payrollRun': 'Cycle de paie {period}',
  'rep.trial.term': 'Période {term} {year}',
  'rep.trial.accrualYear': 'Année d\'acquisition {year}',
  'vehiclePolicy.dialogTitle': 'Véhicule et frais de véhicule',
  'vehiclePolicy.intro': 'Choisissez comment Plumme doit traiter le carburant, l\'atelier et les autres frais clairement liés au véhicule. Il s\'agit d\'un paramètre de travail pour les suggestions de justificatifs, qui n\'enregistre pas le véhicule comme actif.',
  'vehiclePolicy.optionVat': 'Véhicule avec déduction de TVA',
  'vehiclePolicy.optionVatSub': 'L\'entreprise possède ou loue le véhicule, le type de véhicule ouvre droit à déduction, et la dépense concerne une activité enregistrée soumise à la TVA.',
  'vehiclePolicy.optionNoVat': 'Véhicule sans déduction de TVA',
  'vehiclePolicy.optionNoVatSub': 'Proposer les frais de véhicule sans déduction de la TVA déductible.',
  'vehiclePolicy.optionManual': 'Vérifier chaque justificatif manuellement',
  'vehiclePolicy.optionManualSub': 'Plumme propose le compte, mais laisse la déduction de TVA à vérifier.',
  'vehiclePolicy.validFrom': 'Applicable à partir du',
  'vehiclePolicy.noEndDateWarning': 'Sans date de fin, le choix reste valable jusqu\'à ce que vous le modifiiez. Un nouveau choix met automatiquement fin au précédent à la date du changement.',
  'vehiclePolicy.responsibility': 'Je confirme que ces informations sont exactes et comprends que je dois les mettre à jour moi-même si le véhicule est vendu, si le contrat de leasing prend fin ou si le type ou l\'usage du véhicule change.',
  'vehiclePolicy.receiptTitle': 'Clarifier le véhicule une seule fois',
  'vehiclePolicy.receiptText': 'Les justificatifs de carburant et d\'atelier ultérieurs pourront alors recevoir automatiquement la bonne suggestion de TVA.',
  'vehiclePolicy.changeFromReceiptTitle': 'Modifier la règle du véhicule ?',
  'vehiclePolicy.changeFromReceiptText': 'Vous avez réglé ce justificatif de véhicule sur 0 % de déduction de TVA. Cela doit-il s\'appliquer uniquement à ce justificatif, ou Plumme doit-il désormais traiter les frais de véhicule sans déduction de TVA parce que le véhicule a été vendu, que le leasing a pris fin ou que le droit à déduction ne s\'applique plus ?',
  'vehiclePolicy.changeFromReceiptDate': 'La nouvelle règle s\'appliquera à partir du {date}.',
  'vehiclePolicy.receiptOnly': 'Uniquement ce justificatif',
  'vehiclePolicy.updateToNoVat': 'Utiliser 0 % désormais',
  'vehiclePolicy.settingsTitle': 'Véhicule et frais de véhicule',
  'vehiclePolicy.settingsText': 'Contrôle les suggestions automatiques pour le carburant, l\'atelier et les autres frais clairement liés au véhicule. Ce paramètre ne comptabilise rien et ne crée ni actif ni contrat de leasing.',
  'vehiclePolicy.choose': 'Choisir le paramètre',
  'vehiclePolicy.change': 'Modifier le paramètre',
  'vehiclePolicy.save': 'Enregistrer et appliquer',
  'vehiclePolicy.saved': 'Le paramètre du véhicule a été enregistré.',
  'vehiclePolicy.saveError': 'Impossible d\'enregistrer le paramètre du véhicule.',
  'vehiclePolicy.chooseError': 'Choisissez comment traiter les justificatifs de véhicule.',
  'vehiclePolicy.confirmError': 'Confirmez que l\'entreprise tiendra elle-même ces informations à jour.',
  'vehiclePolicy.notConfigured': 'Non configuré – les justificatifs de véhicule doivent être vérifiés',
  'vehiclePolicy.activeFrom': 'Applicable à partir du',
  'vehiclePolicy.noEndDate': 'pas de date de fin',
  'vehiclePolicy.mode.vat_deductible': 'Véhicule avec déduction de TVA',
  'vehiclePolicy.mode.no_vat_deduction': 'Véhicule sans déduction de TVA',
  'vehiclePolicy.mode.manual_review': 'Vérification manuelle de chaque justificatif',
  'buy.vatDeduction': 'Déduction de la TVA déductible',
  'buy.vatDeductionFull': '100 %',
  'buy.vatDeductionNone': '0 %',
  'buy.vatDeductionPartial': 'Partielle',
  'buy.vatDeductionPercent': 'Pourcentage de déduction',
  'buy.fixedAssetLine': 'Enregistrer la ligne comme immobilisation',
  'buy.fixedAssetLineHelp': 'La ligne est ajoutée au registre des immobilisations au lieu d\'être traitée uniquement comme une charge.',
  'buy.fixedAssetFallback': 'Immobilisation',
  'buy.projectForLine': 'Projet pour cette ligne',
  'sup.credit.created': 'L\'avoir fournisseur a été comptabilisé.',
  'sup.credit.refunded': 'Le remboursement a été comptabilisé.',
  'sup.credit.title': 'Enregistrer un avoir fournisseur',
  'sup.credit.refundTitle': 'Enregistrer le remboursement d\'un avoir',
  'sup.credit.action': 'Comptabiliser l\'avoir',
  'sup.credit.refundAction': 'Enregistrer le remboursement',
});
